<wd-input-container [name]="name" [classes]="classes()" [label]="label" [helpText]="helpText()" [comments]="comments" [hideComments]="hideComments">
	<input
		[name]="'input' + name"
		type="checkbox"
		class="form-control form-check-input"
		[ngClass]="classes() + (icon ? ' has-image' : '')"
		[(ngModel)]="model"
		#inputValue="ngModel"
		(mousedown)="onMouseDown($event)"
		(focus)="onFocus($event)"
		(focusout)="onFocusOut()"
		(ngModelChange)="onChange()"
		[readonly]="disabled()"
		[attr.tabindex]="disabled() ? -1 : 0"
		(click)="onClick($event)"
	/>
	<label *ngIf="icon" [attr.tabindex]="disabled() ? -1 : 0" for="input{{name}}" (keypress)="onKeyPressed($event)" (click)="onClicked($event)" [ngClass]="classes()">
		<bi [ngClass]="{ 'checked': model, 'unchecked': !model }" name="{{icon}}"></bi>
	</label>
</wd-input-container>
